import React from "react";
import { Row, Col, Card, CardBody, Container, CardHeader } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//Import Icons
import Icon from "@ailibs/feather-react-ts";

const Feathericons = () => {
  document.title = "Feather Icons | Khozi";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Icons" breadcrumbItem="Feather Icons" />

          <Row>
            <Col xs={12}>
              <Card>
                <CardHeader className="justify-content-between d-flex align-items-center">
                  <h4 className="card-title">Feather Icons</h4>
                  <p className="m-0 badge badge-primary-subtle py-2">Khozi Only</p>
                </CardHeader>
                <CardBody>
                  <div className="row icon-demo-content">
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="activity" />
                      <span>activity</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="airplay" />
                      <span>airplay</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="alert-circle" />
                      <span>alert-circle</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="alert-octagon" />
                      <span>alert-octagon</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="alert-triangle" />
                      <span>alert-triangle</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="align-center" />
                      <span>align-center</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="align-justify" />
                      <span>align-justify</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="align-left" />
                      <span>align-left</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="align-right" />
                      <span>align-right</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="anchor" />
                      <span>anchor</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="aperture" />
                      <span>aperture</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="archive" />
                      <span>archive</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="arrow-down-circle" />
                      <span>arrow-down-circle</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="arrow-down-left" />
                      <span>arrow-down-left</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="arrow-down-right" />
                      <span>arrow-down-right</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="arrow-down" />
                      <span>arrow-down</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="arrow-left-circle" />
                      <span>arrow-left-circle</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="arrow-left" />
                      <span>arrow-left</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="arrow-right-circle" />
                      <span>arrow-right-circle</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="arrow-right" />
                      <span>arrow-right</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="arrow-up-circle" />
                      <span>arrow-up-circle</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="arrow-up-left" />
                      <span>arrow-up-left</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="arrow-up-right" />
                      <span>arrow-up-right</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="arrow-up" />
                      <span>arrow-up</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="at-sign" />
                      <span>at-sign</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="award" />
                      <span>award</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="bar-chart-2" />
                      <span>bar-chart-2</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="bar-chart" />
                      <span>bar-chart</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="battery-charging" />
                      <span>battery-charging</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="battery" />
                      <span>battery</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="bell-off" />
                      <span>bell-off</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="bell" />
                      <span>bell</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="bluetooth" />
                      <span>bluetooth</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="bold" />
                      <span>bold</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="book-open" />
                      <span>book-open</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="book" />
                      <span>book</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="bookmark" />
                      <span>bookmark</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="box" />
                      <span>box</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="briefcase" />
                      <span>briefcase</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="calendar" />
                      <span>calendar</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="camera-off" />
                      <span>camera-off</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="camera" />
                      <span>camera</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="cast" />
                      <span>cast</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="check-circle" />
                      <span>check-circle</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="check-square" />
                      <span>check-square</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="check" />
                      <span>check</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="chevron-down" />
                      <span>chevron-down</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="chevron-left" />
                      <span>chevron-left</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="chevron-right" />
                      <span>chevron-right</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="chevron-up" />
                      <span>chevron-up</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="chevrons-down" />
                      <span>chevrons-down</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="chevrons-left" />
                      <span>chevrons-left</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="chevrons-right" />
                      <span>chevrons-right</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="chevrons-up" />
                      <span>chevrons-up</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="chrome" />
                      <span>chrome</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="circle" />
                      <span>circle</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="clipboard" />
                      <span>clipboard</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="clock" />
                      <span>clock</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="cloud-drizzle" />
                      <span>cloud-drizzle</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="cloud-lightning" />
                      <span>cloud-lightning</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="cloud-off" />
                      <span>cloud-off</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="cloud-rain" />
                      <span>cloud-rain</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="cloud-snow" />
                      <span>cloud-snow</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="cloud" />
                      <span>cloud</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="code" />
                      <span>code</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="codepen" />
                      <span>codepen</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="codesandbox" />
                      <span>codesandbox</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="coffee" />
                      <span>coffee</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="columns" />
                      <span>columns</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="command" />
                      <span>command</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="compass" />
                      <span>compass</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="copy" />
                      <span>copy</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="corner-down-left" />
                      <span>corner-down-left</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="corner-down-right" />
                      <span>corner-down-right</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="corner-left-down" />
                      <span>corner-left-down</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="corner-left-up" />
                      <span>corner-left-up</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="corner-right-down" />
                      <span>corner-right-down</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="corner-right-up" />
                      <span>corner-right-up</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="corner-up-left" />
                      <span>corner-up-left</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="corner-up-right" />
                      <span>corner-up-right</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="cpu" />
                      <span>cpu</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="credit-card" />
                      <span>credit-card</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="crop" />
                      <span>crop</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="crosshair" />
                      <span>crosshair</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="database" />
                      <span>database</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="delete" />
                      <span>delete</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="disc" />
                      <span>disc</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="dollar-sign" />
                      <span>dollar-sign</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="download-cloud" />
                      <span>download-cloud</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="download" />
                      <span>download</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="droplet" />
                      <span>droplet</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="edit-2" />
                      <span>edit-2</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="edit-3" />
                      <span>edit-3</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="edit" />
                      <span>edit</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="external-link" />
                      <span>external-link</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="eye-off" />
                      <span>eye-off</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="eye" />
                      <span>eye</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="facebook" />
                      <span>facebook</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="fast-forward" />
                      <span>fast-forward</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="feather" />
                      <span>feather</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="figma" />
                      <span>figma</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="file-minus" />
                      <span>file-minus</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="file-plus" />
                      <span>file-plus</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="file-text" />
                      <span>file-text</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="file" />
                      <span>file</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="film" />
                      <span>film</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="filter" />
                      <span>filter</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="flag" />
                      <span>flag</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="folder-minus" />
                      <span>folder-minus</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="folder-plus" />
                      <span>folder-plus</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="folder" />
                      <span>folder</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="framer" />
                      <span>framer</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="frown" />
                      <span>frown</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="gift" />
                      <span>gift</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="git-branch" />
                      <span>git-branch</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="git-commit" />
                      <span>git-commit</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="git-merge" />
                      <span>git-merge</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="git-pull-request" />
                      <span>git-pull-request</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="github" />
                      <span>github</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="gitlab" />
                      <span>gitlab</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="globe" />
                      <span>globe</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="grid" />
                      <span>grid</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="hard-drive" />
                      <span>hard-drive</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="hash" />
                      <span>hash</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="headphones" />
                      <span>headphones</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="heart" />
                      <span>heart</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="help-circle" />
                      <span>help-circle</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="hexagon" />
                      <span>hexagon</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="home" />
                      <span>home</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="image" />
                      <span>image</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="inbox" />
                      <span>inbox</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="info" />
                      <span>info</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="instagram" />
                      <span>instagram</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="italic" />
                      <span>italic</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="key" />
                      <span>key</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="layers" />
                      <span>layers</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="layout" />
                      <span>layout</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="life-buoy" />
                      <span>life-buoy</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="link-2" />
                      <span>link-2</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="link" />
                      <span>link</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="linkedin" />
                      <span>linkedin</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="list" />
                      <span>list</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="loader" />
                      <span>loader</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="lock" />
                      <span>lock</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="log-in" />
                      <span>log-in</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="log-out" />
                      <span>log-out</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="mail" />
                      <span>mail</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="map-pin" />
                      <span>map-pin</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="map" />
                      <span>map</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="maximize-2" />
                      <span>maximize-2</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="maximize" />
                      <span>maximize</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="meh" />
                      <span>meh</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="menu" />
                      <span>menu</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="message-circle" />
                      <span>message-circle</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="message-square" />
                      <span>message-square</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="mic-off" />
                      <span>mic-off</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="mic" />
                      <span>mic</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="minimize-2" />
                      <span>minimize-2</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="minimize" />
                      <span>minimize</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="minus-circle" />
                      <span>minus-circle</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="minus-square" />
                      <span>minus-square</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="minus" />
                      <span>minus</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="monitor" />
                      <span>monitor</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="moon" />
                      <span>moon</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="more-horizontal" />
                      <span>more-horizontal</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="more-vertical" />
                      <span>more-vertical</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="mouse-pointer" />
                      <span>mouse-pointer</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="move" />
                      <span>move</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="music" />
                      <span>music</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="navigation-2" />
                      <span>navigation-2</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="navigation" />
                      <span>navigation</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="octagon" />
                      <span>octagon</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="package" />
                      <span>package</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="paperclip" />
                      <span>paperclip</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="pause-circle" />
                      <span>pause-circle</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="pause" />
                      <span>pause</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="pen-tool" />
                      <span>pen-tool</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="percent" />
                      <span>percent</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="phone-call" />
                      <span>phone-call</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="phone-forwarded" />
                      <span>phone-forwarded</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="phone-incoming" />
                      <span>phone-incoming</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="phone-missed" />
                      <span>phone-missed</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="phone-off" />
                      <span>phone-off</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="phone-outgoing" />
                      <span>phone-outgoing</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="phone" />
                      <span>phone</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="pie-chart" />
                      <span>pie-chart</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="play-circle" />
                      <span>play-circle</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="play" />
                      <span>play</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="plus-circle" />
                      <span>plus-circle</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="plus-square" />
                      <span>plus-square</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="plus" />
                      <span>plus</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="pocket" />
                      <span>pocket</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="power" />
                      <span>power</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="printer" />
                      <span>printer</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="radio" />
                      <span>radio</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="refresh-ccw" />
                      <span>refresh-ccw</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="refresh-cw" />
                      <span>refresh-cw</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="repeat" />
                      <span>repeat</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="rewind" />
                      <span>rewind</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="rotate-ccw" />
                      <span>rotate-ccw</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="rotate-cw" />
                      <span>rotate-cw</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="rss" />
                      <span>rss</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="save" />
                      <span>save</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="scissors" />
                      <span>scissors</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="search" />
                      <span>search</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="send" />
                      <span>send</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="server" />
                      <span>server</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="settings" />
                      <span>settings</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="share-2" />
                      <span>share-2</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="share" />
                      <span>share</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="shield-off" />
                      <span>shield-off</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="shield" />
                      <span>shield</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="shopping-bag" />
                      <span>shopping-bag</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="shopping-cart" />
                      <span>shopping-cart</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="shuffle" />
                      <span>shuffle</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="sidebar" />
                      <span>sidebar</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="skip-back" />
                      <span>skip-back</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="skip-forward" />
                      <span>skip-forward</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="slack" />
                      <span>slack</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="slash" />
                      <span>slash</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="sliders" />
                      <span>sliders</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="smartphone" />
                      <span>smartphone</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="smile" />
                      <span>smile</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="speaker" />
                      <span>speaker</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="square" />
                      <span>square</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="star" />
                      <span>star</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="stop-circle" />
                      <span>stop-circle</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="sun" />
                      <span>sun</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="sunrise" />
                      <span>sunrise</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="sunset" />
                      <span>sunset</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="tablet" />
                      <span>tablet</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="tag" />
                      <span>tag</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="target" />
                      <span>target</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="terminal" />
                      <span>terminal</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="thermometer" />
                      <span>thermometer</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="thumbs-down" />
                      <span>thumbs-down</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="thumbs-up" />
                      <span>thumbs-up</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="toggle-left" />
                      <span>toggle-left</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="toggle-right" />
                      <span>toggle-right</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="tool" />
                      <span>tool</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="trash-2" />
                      <span>trash-2</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="trash" />
                      <span>trash</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="trello" />
                      <span>trello</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="trending-down" />
                      <span>trending-down</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="trending-up" />
                      <span>trending-up</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="triangle" />
                      <span>triangle</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="truck" />
                      <span>truck</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="tv" />
                      <span>tv</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="twitch" />
                      <span>twitch</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="twitter" />
                      <span>twitter</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="type" />
                      <span>type</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="umbrella" />
                      <span>umbrella</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="underline" />
                      <span>underline</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="unlock" />
                      <span>unlock</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="upload-cloud" />
                      <span>upload-cloud</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="upload" />
                      <span>upload</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="user-check" />
                      <span>user-check</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="user-minus" />
                      <span>user-minus</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="user-plus" />
                      <span>user-plus</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="user-x" />
                      <span>user-x</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="user" />
                      <span>user</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="users" />
                      <span>users</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="video-off" />
                      <span>video-off</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="video" />
                      <span>video</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="voicemail" />
                      <span>voicemail</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="volume-1" />
                      <span>volume-1</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="volume-2" />
                      <span>volume-2</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="volume-x" />
                      <span>volume-x</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="volume" />
                      <span>volume</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="watch" />
                      <span>watch</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="wifi-off" />
                      <span>wifi-off</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="wifi" />
                      <span>wifi</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="wind" />
                      <span>wind</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="x-circle" />
                      <span>x-circle</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="x-octagon" />
                      <span>x-octagon</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="x-square" />
                      <span>x-square</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="x" />
                      <span>x</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="youtube" />
                      <span>youtube</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="zap-off" />
                      <span>zap-off</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="zap" />
                      <span>zap</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="zoom-in" />
                      <span>zoom-in</span>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <Icon name="zoom-out" />
                      <span>zoom-out</span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Feathericons;
